/* Ardor DTF Transfer Designer: 2D t-shirt preview. Ardor Printing. New Oct 14, 2026 (written for this designer).
A flat-lay t-shirt drawn from measurements in inches (adult L: 20.5 in chest, 29.4 in long; youth M: 80% of that), in one
of 12 shirt colors, front or back, with the customer's transfer drawn at its true size where it would be pressed.
window.ArdorDtfShirt = { COLORS, PLACEMENTS, colorOf(id), placementOf(id), anchor(area, size), draw(canvas, o), snapshot(w, h, o) }
o = { color: id or '#hex', view: 'front'|'back', size: 'adult'|'youth', prints: [{ area: 'front'|'back'|'sleeveL'|'sleeveR',
      canvas, widthIn, heightIn, xIn, yIn }], label: true }
Print position: xIn = the print's centre from the shirt's centre line (+ = toward the wearer's left side), yIn = from the
area's anchor down to the top of the print. Anchors: front = centre of the front collar seam, back = centre of the back
collar seam, sleeves = the middle of the shoulder seam (yIn runs down the sleeve). Same convention as the 3D view. */
(function () {
  'use strict';
  if (window.ArdorDtfShirt) return;

  var COLORS = [
    { id: 'white', name: 'White', hex: '#FFFFFF' },
    { id: 'black', name: 'Black', hex: '#141414' },
    { id: 'heather-gray', name: 'Heather gray', hex: '#B5B7B9', heather: true },
    { id: 'charcoal', name: 'Charcoal', hex: '#3D3F43', heather: true },
    { id: 'navy', name: 'Navy', hex: '#1D2740' },
    { id: 'royal', name: 'Royal', hex: '#1F4E9E' },
    { id: 'red', name: 'Red', hex: '#C3132B' },
    { id: 'maroon', name: 'Maroon', hex: '#5B1A2A' },
    { id: 'forest', name: 'Forest', hex: '#1F4A2C' },
    { id: 'kelly-green', name: 'Kelly green', hex: '#24954A' },
    { id: 'gold', name: 'Gold', hex: '#F0A81C' },
    { id: 'pink', name: 'Pink', hex: '#F3A7C3' }
  ];
  // where each preset goes and how wide it prints (customers resize freely afterwards)
  var PLACEMENTS = [
    { id: 'leftchest', name: 'Left chest', w: 3.5, area: 'front', x: 4, y: 3, size: 'adult' },
    { id: 'front', name: 'Full front', w: 11, area: 'front', x: 0, y: 3, size: 'adult' },
    { id: 'back', name: 'Full back', w: 12, area: 'back', x: 0, y: 3, size: 'adult' },
    { id: 'sleeve', name: 'Sleeve', w: 3, area: 'sleeveL', x: 0, y: 2.5, size: 'adult' },
    { id: 'youth', name: 'Youth front', w: 9, area: 'front', x: 0, y: 2.5, size: 'youth' }
  ];
  function colorOf(id) {
    for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === id || COLORS[i].hex.toLowerCase() === String(id || '').toLowerCase()) return COLORS[i];
    return /^#[0-9a-f]{6}$/i.test(id || '') ? { id: id, name: id, hex: id } : COLORS[1];
  }
  function placementOf(id) { for (var i = 0; i < PLACEMENTS.length; i++) if (PLACEMENTS[i].id === id) return PLACEMENTS[i]; return PLACEMENTS[1]; }

  // ---------- the shirt, adult L, inches: x from the centre line (+ = right on the drawing), y down from the shoulder line ----------
  var T = {
    neckW: 3.6, frontDrop: 3.3, backDrop: 0.95, rib: 0.75,
    shoulder: [9.7, 1.7], sleeveTop: [15.3, 7.4], sleeveHem: [12.5, 11.4], underarm: [10.25, 8.9],
    hem: [10.45, 29.0], hemMid: 29.45, width: 31.2, top: -0.5, bottom: 30.2
  };
  function scaleOf(size) { return size === 'youth' ? 0.8 : 1; }
  function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
  // the anchor of a print area (inches, drawing coordinates for the given view) and the direction "down" runs
  function anchor(area, size, view) {
    var k = scaleOf(size);
    if (area === 'back') return { x: 0, y: T.backDrop * k, rot: 0, k: k };
    if (area === 'sleeveL' || area === 'sleeveR') {
      // wearer's left sleeve shows on the right of the front view and on the left of the back view
      var right = (area === 'sleeveL') === (view !== 'back');
      var s = right ? 1 : -1;
      var top = [s * T.shoulder[0] * k, T.shoulder[1] * k], und = [s * T.underarm[0] * k, T.underarm[1] * k];
      var mid = lerp(top, und, 0.5);
      var hm = lerp([s * T.sleeveTop[0] * k, T.sleeveTop[1] * k], [s * T.sleeveHem[0] * k, T.sleeveHem[1] * k], 0.5);
      var ang = Math.atan2(hm[1] - mid[1], hm[0] - mid[0]); // the sleeve's axis, shoulder to hem
      return { x: mid[0], y: mid[1], rot: ang - Math.PI / 2, k: k, sleeve: true, dir: s };
    }
    return { x: 0, y: T.frontDrop * k, rot: 0, k: k };
  }
  function outline(ctx, k) {
    var p = function (x, y) { return [x * k, y * k]; };
    var nw = T.neckW, s = T.shoulder, st = T.sleeveTop, sh = T.sleeveHem, ua = T.underarm, hm = T.hem;
    ctx.beginPath();
    var a = p(-nw, 0); ctx.moveTo(a[0], a[1]);
    var b = p(-s[0], s[1]); ctx.lineTo(b[0], b[1]);
    var c = p(-st[0], st[1]); ctx.quadraticCurveTo((b[0] + c[0]) / 2 - 0.3 * k, (b[1] + c[1]) / 2 - 0.2 * k, c[0], c[1]);
    var d = p(-sh[0], sh[1]); ctx.lineTo(d[0], d[1]);
    var e = p(-ua[0], ua[1]); ctx.quadraticCurveTo((d[0] + e[0]) / 2 + 0.1 * k, (d[1] + e[1]) / 2 + 0.3 * k, e[0], e[1]);
    var f = p(-hm[0], hm[1]); ctx.quadraticCurveTo(e[0] - 0.35 * k, (e[1] + f[1]) / 2, f[0], f[1]);
    var g = p(hm[0], hm[1]); ctx.quadraticCurveTo(0, T.hemMid * k + 0.25 * k, g[0], g[1]);
    var h = p(ua[0], ua[1]); ctx.quadraticCurveTo(h[0] + 0.35 * k, (h[1] + g[1]) / 2, h[0], h[1]);
    var i = p(sh[0], sh[1]); ctx.quadraticCurveTo((i[0] + h[0]) / 2 - 0.1 * k, (i[1] + h[1]) / 2 + 0.3 * k, i[0], i[1]);
    var j = p(st[0], st[1]); ctx.lineTo(j[0], j[1]);
    var l = p(s[0], s[1]); ctx.quadraticCurveTo((j[0] + l[0]) / 2 + 0.3 * k, (j[1] + l[1]) / 2 - 0.2 * k, l[0], l[1]);
    var m = p(nw, 0); ctx.lineTo(m[0], m[1]);
    ctx.closePath();
  }
  function neckPath(ctx, k, drop) { // the neck opening's lower edge as a curve from (-nw, 0) to (nw, 0)
    ctx.moveTo(-T.neckW * k, 0);
    ctx.bezierCurveTo(-T.neckW * k, drop * k * 0.75, -T.neckW * k * 0.55, drop * k, 0, drop * k);
    ctx.bezierCurveTo(T.neckW * k * 0.55, drop * k, T.neckW * k, drop * k * 0.75, T.neckW * k, 0);
  }
  function shade(hex, f) { // f < 0 darker, > 0 lighter
    var v = parseInt(hex.slice(1), 16), r = v >> 16 & 255, g = v >> 8 & 255, b = v & 255;
    var t = f < 0 ? 0 : 255, a = Math.abs(f);
    return 'rgb(' + Math.round(r + (t - r) * a) + ',' + Math.round(g + (t - g) * a) + ',' + Math.round(b + (t - b) * a) + ')';
  }
  function lum(hex) { var v = parseInt(hex.slice(1), 16); return (0.299 * (v >> 16 & 255) + 0.587 * (v >> 8 & 255) + 0.114 * (v & 255)) / 255; }
  var noiseCv = null;
  function noise() {
    if (noiseCv) return noiseCv;
    noiseCv = document.createElement('canvas'); noiseCv.width = noiseCv.height = 160;
    var x = noiseCv.getContext('2d'), im = x.createImageData(160, 160);
    for (var i = 0; i < im.data.length; i += 4) { var v = Math.random() * 255; im.data[i] = im.data[i + 1] = im.data[i + 2] = v; im.data[i + 3] = 26 + Math.random() * 30; }
    x.putImageData(im, 0, 0);
    return noiseCv;
  }

  // ---------- draw ----------
  function draw(cv, o) {
    o = o || {};
    var ctx = cv.getContext('2d'), W = cv.width, H = cv.height;
    var size = o.size === 'youth' ? 'youth' : 'adult', k = scaleOf(size), view = o.view === 'back' ? 'back' : 'front';
    var col = colorOf(o.color || 'black'), hex = col.hex, dark = lum(hex) < 0.45;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, W, H);
    if (o.bg) { ctx.fillStyle = o.bg; ctx.fillRect(0, 0, W, H); }
    // fit the adult shirt (so youth shows smaller, at its true size); pad for the label
    var pad = Math.max(8, Math.min(W, H) * 0.04), labelH = o.label === false ? 0 : Math.max(14, H * 0.045);
    var s = Math.min((W - 2 * pad) / T.width, (H - 2 * pad - labelH) / (T.bottom - T.top));
    var ox = W / 2, oy = pad + (H - 2 * pad - labelH - (T.bottom - T.top) * s) / 2 - T.top * s;
    ctx.setTransform(s, 0, 0, s, ox, oy);
    var lw = 1 / s;
    // soft shadow
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.28)'; ctx.shadowBlur = 0.9 * s; ctx.shadowOffsetY = 0.35 * s;
    outline(ctx, k); ctx.fillStyle = hex; ctx.fill();
    ctx.restore();
    // body color, shading, heather
    ctx.save();
    outline(ctx, k); ctx.clip();
    ctx.fillStyle = hex; ctx.fillRect(-20, -2, 40, 34);
    if (col.heather) { var pat = ctx.createPattern(noise(), 'repeat'); ctx.save(); ctx.scale(0.06, 0.06); ctx.fillStyle = pat; ctx.globalCompositeOperation = dark ? 'screen' : 'multiply'; ctx.fillRect(-340, -40, 680, 560); ctx.restore(); }
    var gx = ctx.createLinearGradient(-11 * k, 0, 11 * k, 0);
    gx.addColorStop(0, 'rgba(0,0,0,.20)'); gx.addColorStop(0.18, 'rgba(0,0,0,.04)'); gx.addColorStop(0.5, 'rgba(255,255,255,.05)'); gx.addColorStop(0.82, 'rgba(0,0,0,.04)'); gx.addColorStop(1, 'rgba(0,0,0,.20)');
    ctx.fillStyle = gx; ctx.fillRect(-20, -2, 40, 34);
    var gy = ctx.createLinearGradient(0, 0, 0, 30 * k);
    gy.addColorStop(0, 'rgba(255,255,255,.06)'); gy.addColorStop(0.7, 'rgba(0,0,0,0)'); gy.addColorStop(1, 'rgba(0,0,0,.12)');
    ctx.fillStyle = gy; ctx.fillRect(-20, -2, 40, 34);
    // a few soft folds
    ctx.globalCompositeOperation = 'multiply';
    [[-6.5, 12, 1.8, 0.08], [5.8, 17, 2.2, 0.07], [-3, 24, 2.6, 0.06]].forEach(function (f) {
      var r = ctx.createRadialGradient(f[0] * k, f[1] * k, 0, f[0] * k, f[1] * k, f[2] * 3 * k);
      r.addColorStop(0, 'rgba(0,0,0,' + f[3] + ')'); r.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = r; ctx.fillRect(-20, -2, 40, 34);
    });
    ctx.restore();

    // the neck opening: the back of the shirt shows through the front neck (front view); the inside of the front shows
    // below the back collar (back view)
    ctx.save();
    var near = view === 'back' ? T.backDrop : T.frontDrop, far = view === 'back' ? T.frontDrop : T.backDrop;
    ctx.beginPath(); neckPath(ctx, k, near); ctx.lineTo(T.neckW * k, -0.6 * k); ctx.lineTo(-T.neckW * k, -0.6 * k); ctx.closePath();
    ctx.fillStyle = shade(hex, dark ? 0.12 : -0.25); ctx.fill();
    ctx.beginPath(); neckPath(ctx, k, far * 0.55); ctx.lineTo(T.neckW * k, -0.6 * k); ctx.lineTo(-T.neckW * k, -0.6 * k); ctx.closePath();
    ctx.fillStyle = shade(hex, dark ? 0.05 : -0.12); ctx.fill();
    // collar rib
    ctx.beginPath(); neckPath(ctx, k, near);
    ctx.lineWidth = T.rib * k; ctx.strokeStyle = shade(hex, dark ? 0.06 : -0.06); ctx.stroke();
    ctx.beginPath(); neckPath(ctx, k, near + T.rib * 0.5);
    ctx.lineWidth = lw * 0.9; ctx.strokeStyle = dark ? 'rgba(255,255,255,.18)' : 'rgba(0,0,0,.22)'; ctx.setLineDash([0.12 * k, 0.1 * k]); ctx.stroke(); ctx.setLineDash([]);
    ctx.restore();

    // seams and hems
    ctx.save();
    ctx.strokeStyle = dark ? 'rgba(255,255,255,.16)' : 'rgba(0,0,0,.16)'; ctx.lineWidth = lw * 0.9;
    [-1, 1].forEach(function (sd) {
      ctx.beginPath(); ctx.moveTo(sd * T.shoulder[0] * k, T.shoulder[1] * k); ctx.quadraticCurveTo(sd * (T.shoulder[0] + 0.6) * k, (T.shoulder[1] + T.underarm[1]) / 2 * k, sd * T.underarm[0] * k, T.underarm[1] * k); ctx.stroke();
      var a = lerp(T.sleeveTop, T.sleeveHem, 0), b = lerp(T.sleeveTop, T.sleeveHem, 1);
      var ins = function (p, t) { return [p[0] - 0.55 * t, p[1] - 0.45 * t]; };
      ctx.setLineDash([0.12 * k, 0.09 * k]);
      ctx.beginPath(); var a1 = ins(a, 1), b1 = ins(b, 1); ctx.moveTo(sd * a1[0] * k, a1[1] * k); ctx.lineTo(sd * b1[0] * k, b1[1] * k); ctx.stroke();
      ctx.setLineDash([]);
    });
    ctx.setLineDash([0.12 * k, 0.09 * k]);
    ctx.beginPath(); ctx.moveTo(-T.hem[0] * k, (T.hem[1] - 0.9) * k); ctx.quadraticCurveTo(0, (T.hemMid - 0.65) * k, T.hem[0] * k, (T.hem[1] - 0.9) * k); ctx.stroke();
    ctx.setLineDash([]);
    ctx.restore();

    // prints, true size, then a little of the shirt's shading over them
    var prints = (o.prints || []).filter(function (p) { return p && p.canvas && p.widthIn > 0 && p.heightIn > 0; });
    var shown = [];
    prints.forEach(function (p) {
      var area = p.area || 'front';
      if ((area === 'front' && view === 'back') || (area === 'back' && view !== 'back')) return;
      var an = anchor(area, size, view);
      ctx.save();
      outline(ctx, k); ctx.clip();
      ctx.translate(an.x, an.y);
      ctx.rotate(an.rot);
      var side = an.sleeve ? an.dir * (view === 'back' ? -1 : 1) : (view === 'back' ? -1 : 1); // + x = toward the wearer's left
      var cx = (p.xIn || 0) * (an.sleeve ? 1 : side), top = p.yIn == null ? 3 : p.yIn;
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(p.canvas, cx - p.widthIn / 2, top, p.widthIn, p.heightIn);
      ctx.restore();
      shown.push(p);
    });
    if (shown.length) {
      ctx.save(); outline(ctx, k); ctx.clip();
      var gx2 = ctx.createLinearGradient(-11 * k, 0, 11 * k, 0);
      gx2.addColorStop(0, 'rgba(0,0,0,.12)'); gx2.addColorStop(0.2, 'rgba(0,0,0,0)'); gx2.addColorStop(0.8, 'rgba(0,0,0,0)'); gx2.addColorStop(1, 'rgba(0,0,0,.12)');
      ctx.globalCompositeOperation = 'multiply'; ctx.fillStyle = gx2; ctx.fillRect(-20, -2, 40, 34);
      ctx.restore();
    }
    // outline
    ctx.save(); outline(ctx, k); ctx.lineWidth = lw * 1.1; ctx.strokeStyle = dark ? 'rgba(255,255,255,.10)' : 'rgba(0,0,0,.18)'; ctx.stroke(); ctx.restore();

    // label under the shirt
    if (labelH) {
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.fillStyle = o.labelColor || '#6B6F76';
      ctx.font = '600 ' + Math.round(labelH * 0.62) + 'px Jost, "Helvetica Neue", Arial, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var txt = (size === 'youth' ? 'Youth M shirt' : 'Adult L shirt') + ', ' + col.name.toLowerCase() + ', ' + (view === 'back' ? 'back' : 'front');
      if (shown.length === 1) txt += '  |  print ' + fmt(shown[0].widthIn) + ' x ' + fmt(shown[0].heightIn) + ' in, true size';
      ctx.fillText(txt, W / 2, H - pad / 2 - labelH / 2);
    }
    return { scale: s, ox: ox, oy: oy, shown: shown.length };
  }
  function fmt(n) { return String(Math.round(n * 100) / 100); }
  function snapshot(w, h, o) { var cv = document.createElement('canvas'); cv.width = w; cv.height = h; draw(cv, o); return cv; }

  window.ArdorDtfShirt = { version: '1.0.0', COLORS: COLORS, PLACEMENTS: PLACEMENTS, colorOf: colorOf, placementOf: placementOf, anchor: anchor, draw: draw, snapshot: snapshot, T: T };
})();
